import {getConfig} from '../../../i18n/Metronici18n'
import {urlPattern} from '../regexs'

export const establishOwnerFromDomain = () => {
  const host = establishHostFromUrl()

  // console.log('establishOwnerFromDomain', host?.replace('www.', ''))

  switch (host?.replace('www.', '')) {
    case 'vectorchina.biz':
      return 3
    case 'vectorlogistic.net':
      return 6
    case 'vector-usa.biz':
    case 'vector.org':
    case 'localhost':
      return 1
    case 'pokupka.eu':
      return 8
    default:
      return 1
  }
}

export const getHostUrl = () => {
  const url = new URL(window.location.href)
  const host = url.hostname.replace(/((www.)?my.)/, '')
  return host
}

export const establishHostFromUrl = () => {
  const host = getHostUrl()

  const isValidUrl = urlPattern.test(host)

  if (host === 'localhost') {
    return 'localhost'
  } else if (isValidUrl) {
    return 'www.' + host
  } else {
    return ''
  }
}

// kostyl' till we come up with a way to pass the name of country
export const establishCountryFromOwner = () => {
  const host = establishHostFromUrl()
  const {selectedLang} = getConfig()

  const countries: {uk: string; ru: string; abbr: string}[] = [
    {uk: 'Китаї', ru: 'Китае', abbr: 'CHINA'},
    {uk: 'США', ru: 'США', abbr: 'USA'},
  ]

  switch (host?.replace('www.', '')) {
    case 'vectorchina.biz':
      return {
        name: countries[0][selectedLang as keyof typeof countries[0]],
        abbr: countries[0].abbr,
      }
    case 'vectorlogistic.net':
      return {
        name: countries[1][selectedLang as keyof typeof countries[1]],
        abbr: countries[1].abbr,
      }
    case 'vector-usa.biz':
    case 'vector.org':
      return {
        name: countries[1][selectedLang as keyof typeof countries[1]],
        abbr: countries[1].abbr,
      }
    default:
      return {
        name: countries[1][selectedLang as keyof typeof countries[1]],
        abbr: countries[1].abbr,
      }
  }
}
